module.exports = __webpack_public_path__ + "static/media/meteringicon03.a6ea8338.png";